import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { GET_ROUTING_IMPORT_PLAN_COMPARISON } from 'src/graphql/requests/getRoutingImportPlanComparison';
import { client } from 'src/graphql/client';
import {
  ActualRoutesSummary,
  RoutificRunSummary,
} from 'src/graphql/types/delivery';
import { GGetRoutingImportPlanComparisonQuery } from 'src/graphql/types/generated';
import { DeliveryState } from './state';

type GetScenarioComparisonResult = {
  scenarios: RoutificRunSummary[];
  actualRoutesSummary: ActualRoutesSummary | undefined;
};

export const getScenarioComparison = createAsyncThunk(
  'delivery/getScenarioComparison',
  async (
    { warehouseId, nightEnd }: { warehouseId: string; nightEnd: string },
    _thunkAPI,
  ): Promise<GetScenarioComparisonResult | null> => {
    const { data, error } = await client
      .query<GGetRoutingImportPlanComparisonQuery>(
        GET_ROUTING_IMPORT_PLAN_COMPARISON,
        { input: { warehouseId, nightEnd } },
        { requestPolicy: 'network-only' },
      )
      .toPromise();

    if (error || !data?.routingImportPlan) {
      console.error('Failed to fetch scenario comparison data');
      console.error(error);
      return null;
    }

    return {
      scenarios: data.routingImportPlan.scenarios,
      actualRoutesSummary:
        data.routingImportPlan.actualRoutesSummary ?? undefined,
    };
  },
);

export const getScenarioComparisonFulfilled = (
  state: DeliveryState,
  action: PayloadAction<GetScenarioComparisonResult | null>,
): void => {
  if (action.payload) {
    state.routeImport = {
      ...state.routeImport,
      scenarios: action.payload.scenarios,
      actualRoutesSummary: action.payload.actualRoutesSummary,
      scenariosLoading: false,
      scenariosError: false,
    };
  } else {
    state.routeImport = {
      ...state.routeImport,
      scenariosLoading: false,
      scenariosError: true,
    };
  }
};

export const getScenarioComparisonPending = (state: DeliveryState): void => {
  state.routeImport = {
    ...state.routeImport,
    scenariosLoading: true,
    scenariosError: false,
  };
};

// Fires only if the thunk's async function throws (e.g. URQL client setup
// failure). GraphQL/network errors are caught internally and return null,
// routing through getScenarioComparisonFulfilled instead.
export const getScenarioComparisonRejected = (state: DeliveryState): void => {
  state.routeImport = {
    ...state.routeImport,
    scenariosLoading: false,
    scenariosError: true,
  };
};
